import styled from "styled-components";

export const Container = styled.div`
    align-items: end;
    display: flex;
    justify-content: center;
    padding-inline: 20px;
    @media (orientation: landscape) and (max-width: 1080px){
        width: 10px;
    }
`;

export const ContainerContent = styled.div`
    background: transparent;
    display: flex;
    height: 100px;
    @media (min-width: 720px) {
        height: 132px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        height: 100px;
    }
`;

export const Bar = styled.div`
    align-items: center;
    background: ${props => (props.$isfocus ? '#D9D9D9' : '#fff')};
    border-radius: 50px;
    display: flex;
    height: 100%;
    justify-content: center;
    position: relative;
    width: 12px;
    @media (min-width: 720px) {
        width: 16px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        width: 12px;
    }
`;

export const BarFill = styled.div`
    align-items: flex-end;
    background: #D9D9D9;
    border-radius: 50px;
    display: flex;
    height: 90%;
    position: relative;
    width: 6px;
`;

export const BarContent = styled.div`
    background: ${props => (props.color)};
    border-radius: 50px;
    height: ${props => (props.$value)+'%'};
    width: 6px;
`;

export const BallContainer =styled.div`
    align-items: center;
    align-self: center;
    bottom: ${props => (props.$value)+'%'};
    display: flex;
    justify-content: center;
    position: absolute;
    width: 100%;
    z-index: 1000;
`;

export const Ball = styled.div`
    background: ${props => (props.$isfocus ? '#D9D9D9' : '#fff')};;
    border-radius: 50%;
    height: 26px;
    position: absolute;
    width: 26px;
    @media (min-width: 720px) {
        height: 34px;
        width: 34px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        height: 26px;
        width: 26px;
    }
`;

export const BallColor = styled.div`
    background: ${props => (props.color)};
    border-radius: 50%;
    height: 18px;
    position: absolute;
    width: 18px;
    @media (min-width: 720px) {
        height: 22px;
        width: 22px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        height: 18px;
        width: 18px;
    }
`;